import { render, staticRenderFns } from "./SageInvoiceModal.vue?vue&type=template&id=4eba20f2&"
import script from "./SageInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./SageInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports